import { render, staticRenderFns } from "./EDS.vue?vue&type=template&id=134678aa&scoped=true"
import script from "./EDS.vue?vue&type=script&lang=js"
export * from "./EDS.vue?vue&type=script&lang=js"
import style0 from "./EDS.vue?vue&type=style&index=0&id=134678aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134678aa",
  null
  
)

export default component.exports